module.exports = __webpack_public_path__ + "img/arrow-left.1f7b3733.svg";